import { useListPager } from '@airship-platform/airship-patterns';
import { EmptyState, FlexBox } from '@airship-platform/jam-web/components';
import { ProposalTemplateTag } from '@airship-platform/airship-proposal';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { Fragment, useState } from 'react';
import { ProposalTemplate } from '../../../data-access/proposalTemplate';
import ProposalTemplateCard from './ProposalTemplateCard';

type ProposalTemplatesQueryResultsProps = {
  proposalTemplateTags: ProposalTemplateTag[];
  proposalTemplates: ProposalTemplate[];
};

const ProposalTemplatesQueryResults: React.FC<
  ProposalTemplatesQueryResultsProps
> = ({ proposalTemplateTags, proposalTemplates }) => {
  const [pageCounter, setPageCounter] = useState(20);

  const { loaderRef } = useListPager({
    incrementBy: 20,
    initialValue: pageCounter,
    maxValue: proposalTemplates.length,
    callbackFn: setPageCounter,
  });

  const pagedTemplates = proposalTemplates.slice(0, pageCounter);

  if (!proposalTemplates.length) {
    return (
      <EmptyState
        title="No templates found"
        subtitle={'Please adjust your filters.'}
      />
    );
  }

  return (
    <FlexBox flexDirection={'column'} gap={2} width={'100%'}>
      {pagedTemplates.map((proposal, idx) => (
        <Fragment key={proposal.proposalTemplateId}>
          <ProposalTemplateCard
            proposalTemplateTags={proposalTemplateTags.filter((tag) =>
              proposal.tagIds.includes(tag.proposalTemplateTagId)
            )}
            proposalTemplate={proposal}
          />
          {idx < proposalTemplates.length - 1 && (
            <Divider flexItem sx={{ borderColor: 'grey.400' }} />
          )}
        </Fragment>
      ))}
      <Box ref={loaderRef} sx={{ height: 50 }} />
    </FlexBox>
  );
};

export default ProposalTemplatesQueryResults;
